/***
 *
 *   NO PROJECTS
 *   Phase 10 — EmptyState instead of error Message banner.
 *
 **********/

import React from 'react';
import { EmptyState, Button, useNavigate } from 'components/lib';
import { useTranslate } from 'app/translations';

export function NoProjects(props) {
    const { _t } = useTranslate();
    const navigate = useNavigate();

    return (
        <div className="mx-auto max-w-lg px-6 py-16">
            <EmptyState
                icon="folder"
                title={_t('error.project.title')}
                text={_t('error.project.empty')}>
                <Button
                    variant="accent"
                    size="sm"
                    text={_t('message.home')}
                    action={() => navigate('/')}
                />
            </EmptyState>
        </div>
    );
}
